"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'chalkboard',
    name: 'Chalkboard',
    background_color: '#343434',
    background_image: 'https://assets.raydiant.com/images/chalkboard.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/chalkboard-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/ShadowsIntoLightTwo-Regular.woff',
    heading_text_color: '#ffad0a',
    heading_2_font: 'https://fonts.raydiant.com/PermanentMarker-Regular.woff',
    heading_2_text_color: '#f6f6f6',
    body_font: 'https://fonts.raydiant.com/Roboto-Light.woff',
    body_text_color: '#f6f6f6',
    border_color: '#ffffff',
};
//# sourceMappingURL=chalkboard.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/chalkboard.js